import { dew as _environmentsDew } from "../../../../environments";
import { dew as _coreDew } from "../../../../core";
import { dew as _Dew } from "../../..";
import * as _urlSearchParams2 from "@ungap/url-search-params";
var _urlSearchParams = "default" in _urlSearchParams2 ? _urlSearchParams2.default : _urlSearchParams2;
import * as _urlJoin2 from "url-join";
var _urlJoin = "default" in _urlJoin2 ? _urlJoin2.default : _urlJoin2;
import { dew as _serializationDew } from "../../../../serialization";
import { dew as _errorsDew } from "../../../../errors";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  /**
   * This file was auto-generated by Fern from our API Definition.
   */
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = exports && exports.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
  var __awaiter = exports && exports.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Workbooks = void 0;
  const environments = __importStar(_environmentsDew());
  const core = __importStar(_coreDew());
  const Flatfile = __importStar(_Dew());
  const url_search_params_1 = __importDefault(_urlSearchParams);
  const url_join_1 = __importDefault(_urlJoin);
  const serializers = __importStar(_serializationDew());
  const errors = __importStar(_errorsDew());
  class Workbooks {
    constructor(_options) {
      this._options = _options;
    }
    /**
     * Returns all workbooks matching a filter for an account or space
     * @throws {@link Flatfile.BadRequestError}
     */
    list(request = {}, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const {
          spaceId,
          includeCounts
        } = request;
        const _queryParams = new url_search_params_1.default();
        if (spaceId != null) {
          _queryParams.append("spaceId", spaceId);
        }
        if (includeCounts != null) {
          _queryParams.append("includeCounts", includeCounts.toString());
        }
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, "/workbooks"),
          method: "GET",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          queryParameters: _queryParams,
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.ListWorkbooksResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Creates a workbook and adds it to a space
     * @throws {@link Flatfile.BadRequestError}
     */
    create(request, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, "/workbooks"),
          method: "POST",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          body: yield serializers.CreateWorkbookConfig.jsonOrThrow(request, {
            unrecognizedObjectKeys: "strip"
          }),
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.WorkbookResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Returns a single workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    get(workbookId, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}`),
          method: "GET",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.WorkbookResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Deletes a workbook and all of its record data permanently
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    delete(workbookId, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}`),
          method: "DELETE",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.Success.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Updates a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    update(workbookId, request, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}`),
          method: "PATCH",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          body: yield serializers.WorkbookUpdate.jsonOrThrow(request, {
            unrecognizedObjectKeys: "strip"
          }),
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.WorkbookResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Clones a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    clone(workbookId, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/clone`),
          method: "POST",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.WorkbookResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Returns sheets from a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getSheetsDeprecated(workbookId, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets`),
          method: "GET",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.ListSheetsResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Rebuild a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    rebuildWorkbook(workbookId, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/rebuild`),
          method: "POST",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.Success.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Returns records from a sheet in a workbook
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    getRecordsDeprecated(workbookId, sheetId, request = {}, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const {
          versionId,
          untilVersionId,
          sinceVersionId,
          sortField,
          sortDirection,
          filter,
          filterField,
          searchValue,
          searchField,
          pageSize,
          pageNumber,
          includeCounts,
          includeLinks,
          includeMessages
        } = request;
        const _queryParams = new url_search_params_1.default();
        if (versionId != null) {
          _queryParams.append("versionId", versionId);
        }
        if (untilVersionId != null) {
          _queryParams.append("untilVersionId", untilVersionId);
        }
        if (sinceVersionId != null) {
          _queryParams.append("sinceVersionId", sinceVersionId);
        }
        if (sortField != null) {
          _queryParams.append("sortField", sortField);
        }
        if (sortDirection != null) {
          _queryParams.append("sortDirection", sortDirection);
        }
        if (filter != null) {
          _queryParams.append("filter", filter);
        }
        if (filterField != null) {
          _queryParams.append("filterField", filterField);
        }
        if (searchValue != null) {
          _queryParams.append("searchValue", searchValue);
        }
        if (searchField != null) {
          _queryParams.append("searchField", searchField);
        }
        if (pageSize != null) {
          _queryParams.append("pageSize", pageSize.toString());
        }
        if (pageNumber != null) {
          _queryParams.append("pageNumber", pageNumber.toString());
        }
        if (includeCounts != null) {
          _queryParams.append("includeCounts", includeCounts.toString());
        }
        if (includeLinks != null) {
          _queryParams.append("includeLinks", includeLinks.toString());
        }
        if (includeMessages != null) {
          _queryParams.append("includeMessages", includeMessages.toString());
        }
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
          method: "GET",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          queryParameters: _queryParams,
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.RecordsResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Updates existing records in a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    updateRecordsDeprecated(workbookId, sheetId, request, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
          method: "PUT",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          body: yield serializers.Records.jsonOrThrow(request, {
            unrecognizedObjectKeys: "strip"
          }),
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.VersionResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Adds records to a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    addRecordsDeprecated(workbookId, sheetId, request, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
          method: "POST",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          body: yield serializers.workbooks.addRecordsDeprecated.Request.jsonOrThrow(request, {
            unrecognizedObjectKeys: "strip"
          }),
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.RecordsResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Deletes records from a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    deleteRecordsDeprecated(workbookId, sheetId, request = {}, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const {
          ids
        } = request;
        const _queryParams = new url_search_params_1.default();
        if (ids != null) {
          if (Array.isArray(ids)) {
            for (const _item of ids) {
              _queryParams.append("ids", _item);
            }
          } else {
            _queryParams.append("ids", ids);
          }
        }
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/records`),
          method: "DELETE",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          queryParameters: _queryParams,
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.Success.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Trigger data hooks and validation to run on a sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    validateSheetDeprecated(workbookId, sheetId, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/validate`),
          method: "POST",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.Success.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Creates a new version of a workbook sheet
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    createVersionDeprecated(workbookId, sheetId, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/workbooks/${yield serializers.WorkbookId.jsonOrThrow(workbookId)}/sheets/${yield serializers.SheetId.jsonOrThrow(sheetId)}/versions`),
          method: "POST",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.VersionResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    _getAuthorizationHeader() {
      return __awaiter(this, void 0, void 0, function* () {
        return `Bearer ${yield core.Supplier.get(this._options.token)}`;
      });
    }
  }
  exports.Workbooks = Workbooks;
  return exports;
}